import React from "react";
import { connect } from "react-redux";
import { showSnack } from "react-redux-snackbar";
import { ThunkDispatch } from "redux-thunk";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Col,
  Dropdown,
  DropdownToggle,
  Row,
  DropdownItem,
  DropdownMenu,
  Label
} from "reactstrap";
import { FeedbackState, FeedbackCategory } from "../../../Constants/feedbackEnums";
import { IAppState, ApiRequest, LoadingDisplay } from "../../../../Common";
import { feedbackForceTransitionStateService } from "../../../Services/FeedbackForceTransitionStateService";
import { Feedback, endpoints } from "../../..";
import { endpoints as workflowEndpoints } from "../../../../Workflows/Constants/endpoints";
import ResponseHandler from "../../../../App/ResponseHandler";
import { WorkflowState } from "../../../../Workflows/Models/WorkflowState";
import FeedbackForceTransitionStateModal from "./FeedbackForceTransitionStateModal";

type Props = {
  feedback: Feedback;
  onStateChange?: (feedbackCode: string, newState: WorkflowState) => void;
};

type State = {
  modalOpen: boolean;
};

export default class FeedbackForceTransitionStateButton extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      modalOpen: false
    };

    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal() {
    this.setState((prevState: State) => ({
      modalOpen: !prevState.modalOpen
    }));
  }

  render() {
    return (
      <span>
        <Button color="danger" onClick={this.toggleModal}>
          State Override
        </Button>
        <FeedbackForceTransitionStateModal
          {...this.props}
          isModalOpen={this.state.modalOpen}
          toggleModal={this.toggleModal}
        />
      </span>
    );
  }
}
